<div>
  <form [formGroup]="emailForm">
    <div class="form-container">
      <div fxLayout="column">
        @if (
          isEmailTypeInvitee ||
          isEmailTypeInvitees ||
          isEmailTypeTeamMembers ||
          isEmailTypeInvitationReminder ||
          isEmailTypeBulk ||
          isEmailTypeSingle ||
          isEmailTypeWallCertificate ||
          isEmailTypePortalInvitation
        ) {
          <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>Email template</mat-label>
            <mat-select
              formControlName="emailTemplate"
              placeholder="No template selected"
              (selectionChange)="emailTemplateSelected()"
            >
              @for (template of emailTemplates; track template) {
                <mat-option [value]="template">
                  {{ template.templateName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>From</mat-label>
          <input
            matInput
            forbidAngleBrackets
            class="from-name-input"
            type="text"
            formControlName="fromName"
          />
          @if (emailForm?.get('fromName')?.hasError('required')) {
            <mat-error> From is required </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Reply to email</mat-label>
          <input
            matInput
            forbidAngleBrackets
            class="reply-to-input"
            type="text"
            formControlName="replyTo"
          />
          @if (emailForm?.get('replyTo')?.hasError('required')) {
            <mat-error> Reply to email is required </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Subject line</mat-label>
          <input
            matInput
            forbidAngleBrackets
            class="subject-input"
            type="text"
            formControlName="subject"
            placeholder="subject"
          />
          @if (emailForm?.get('subject')?.hasError('required')) {
            <mat-error> Subject is required </mat-error>
          }
        </mat-form-field>
        <div class="text-editor-container">
          <rich-text-editor
            [form]="emailForm"
            [includeTeamData]="!generalEmailTemplate"
            [includePersonData]="true"
            [attributes]="attributes"
            field="content"
            label="Message *"
            placeholder="message body"
          >
          </rich-text-editor>
        </div>
        @if (isEmailTypeInvitee || isEmailTypeInvitees) {
          <div fxLayout="column" class="reminder-controls">
            <div fxLayout="row" (mouseup)="showPlanUpgradePrompt()">
              <mat-checkbox
                color="primary"
                formControlName="scheduleReminder"
                [disabled]="!canScheduleReminders"
              >
                Schedule a reminder email
              </mat-checkbox>
              @if (!canScheduleReminders) {
                <mat-icon class="lock-icon">lock</mat-icon>
              }
            </div>
            @if (emailForm?.get('scheduleReminder')?.value) {
              <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                <mat-select formControlName="reminderDaysPreset">
                  <mat-option value="2">2 days from now</mat-option>
                  <mat-option value="7">7 days from now</mat-option>
                  <mat-option value="14">14 days from now</mat-option>
                  <mat-option value="custom">Custom</mat-option>
                </mat-select>
              </mat-form-field>
            }
            @if (
              emailForm?.get('scheduleReminder')?.value &&
              emailForm?.get('reminderDaysPreset')?.value === 'custom'
            ) {
              <div
                fxLayout="row"
                fxLayoutAlign="left center"
                class="reminder-custom-days"
              >
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="number"
                    min="1"
                    formControlName="reminderDaysCustom"
                  />
                </mat-form-field>
                <mat-label>days from now</mat-label>
              </div>
            }
            @if (emailForm.hasError('wholeNumber')) {
              <mat-error> A whole number is required </mat-error>
            }
            @if (emailForm?.get('reminderDaysCustom')?.hasError('min')) {
              <mat-error> A positive number is required </mat-error>
            }
          </div>
        }
      </div>
    </div>
  </form>
  <div class="step-buttons" fxLayout fxLayoutGap="10px">
    @if (
      isEmailTypeInvitee ||
      isEmailTypeInvitees ||
      isEmailTypeTeamMembers ||
      isEmailTypeSurvey ||
      isEmailTypeTeamForm
    ) {
      <div>
        <button
          mat-flat-button
          color="primary"
          matStepperNext
          [disabled]="!stepComposeEmailValid()"
          id="compose-email-button"
        >
          Next
        </button>
        @if (!isEmailTypeInvitee) {
          <button mat-flat-button matStepperPrevious class="back-button">
            Back
          </button>
        }
      </div>
    }
    <preview-template-message
      class="preview-button"
      [templateName]="getTemplateName()"
      [subject]="emailForm?.get('subject')?.value"
      [fromName]="emailForm?.get('fromName')?.value"
      [replyTo]="emailForm?.get('replyTo')?.value"
      [content]="emailForm?.get('content')?.value"
      [buttonText]="getButtonText()"
      [link]="getButtonLink()"
      [personId]="this.recipientPersonId"
      [isEmailComposed]="stepComposeEmailValid()"
    >
    </preview-template-message>
  </div>
</div>
